
export default {
  'm':{
    'sms_login':'Login pesan singkat',
    'get_vercode':'Kirim',
    'change_mobile':'Ganti nomor telepon',
    'log_reg_agree':'Masuk/Daftar berarti setuju dengan {msg_ss}',
    'old_mobile':'Nomor telepon asli',
    'new_mobile':'Nomor telepon baru',
    'agency_reginfo_fill':'Isi informasi pendaftaran guild',
    'audit_res':'Hasil audit',
    'agency_name':'Nama serikat',
    'agency_name_input':'Silakan masukkan nama guild',
    'agency_name_input_note':'Catatan: Nama Guild disarankan singkat dan mudah diingat, tidak lebih dari 30 kata',
    'agency_logo':'LOGO serikat',
    'agency_logo_unpload_note':'Harap unggah LOGO serikat yang jelas dalam format PNG/JPG/JPEG',
    'agency_contact_name':'Kontak person serikat',
    'user_contact_name':'Silakan isi nama orang yang melakukan kontak sehari-hari dengan platform pengguna',
    'agency_contact_phone':'Nomor telepon kontak serikat',
    'agency_whatsapp':'Pemimpin serikat WhatsApp',
    'agency_whatsapp_contact':'Silakan masukkan informasi kontak WhatsApp dari pemimpin serikat',
    'agency_use_lang':'Bahasa yang digunakan oleh pemimpin guild',
    'agency_head_ID':'ID pemimpin serikat',
    'agency_ID_input':'Silakan masukkan ID pengguna dari pemimpin serikat BuzzCast APP untuk distribusi dana nanti',
    'reg_country':'Negara pendaftaran',
    'inhand_ID_photo':'ID foto di tangan',
    'upload_note_t':'Unggah pertimbangan',
    'agency_self_inhand_ID':'Pemimpin guild harus memegang paspor untuk difoto',
    'photo_must_clearly':'Sisi depan harus dengan jelas menunjukkan orang tersebut dan informasi paspor asli dengan mengambil foto',
    'mian_form_country':'Negara sumber utama tuan rumah',
    'invite_code':'Kode undangan',
    'your_profile_submit_success':'Dokumen Anda telah berhasil dikirim! kami akan menanganinya sesegera mungkin.<br>Hasil audit akan dikirim ke pemberitahuan BuzzCast APP dari pemimpin serikat, dan harap perhatikan untuk memeriksa!',
    'your_profile_approved':'Dokumen yang Anda kirimkan tidak lolos peninjauan! Alasan penolakan adalah foto paspor pemegang tidak jelas".<br>Silakan isi ulang atau hubungi asisten resmi di BuzzCastAPP untuk konsultasi.',
    'return_refill':'Kembali dan isi ulang',
    'success_agency':'Selamat atas keberhasilan Anda menyelesaikan platform, [klik saya] untuk mulai bekerja!',
    'personal_account':'Akun pribadi',
    'my_agency':'Serikat saya',
    'your_agency_been_forcibly':'Guild Anda telah dihentikan secara paksa oleh platform, dan Anda tidak akan bisa lagi masuk ke sistem. Jika Anda memiliki pertanyaan, silakan hubungi asisten resmi BuzzCastAPP atau operasi eksklusif.',
    'invite_live_join':'Undang tuan rumah untuk bergabung dengan tautan guild',
    'base_info':'Informasi dasar',
    'apply_time':'Tanggal Aplikasi',
    'join_time':'Waktu bergabung',
    'cooper_status':'Status kerjasama',
    'streamer_manage':'Manajemen tuan rumah',
    'sereamer_apply':'Persetujuan tuan rumah',
    'sereamer_nickname':'Nama panggilan tuan rumah',
    'remark':'Komentar',
    'no_remark':'Tidak ada komentar',
    'add_remark':'Tambahkan komentar',
    'birth':'Tanggal lahir',
    'user_status':'Status pengguna',
    'temporarily_frozen':'Pembekuan sementara',
    'permanently_frozen':'Beku selamanya',
    'fans_num':'Jumlah pengikut',
    'sign_status':'Status kontrak',
    'sign_ing':'Dibawah kontrak',
    'sign_time':'Tanggal kontrak',
    'release_time':'Tanggal pembatalan',
    'live_viola_record':'Catatan pelanggaran siaran langsung',
    'sign_record':'Catatan kontrak',
    'current_contract_status':'Status kontrak saat ini',
    'termination_reason':'Alasan penghentian',
    'violation_reason':'Alasan pelanggaran',
    'violation_time':'Tanggal pelanggaran',
    'processing_result':'Hasil proses',
    'exported_data':'Ekspor data',
    'join_agency_apply':'Persetujuan untuk bergabung dengan guild',
    'audit_status':'Status persetujuan',
    'pending_review':'Tinjauan tertunda',
    'pending_HQ_review':'Menunggu peninjauan kantor pusat',
    'not_approved_HQ':'Peninjauan kantor pusat gagal',
    'withdrawn':'Dicabut',
    'audit_trail':'Tinjau catatan',
    'oper':'Operasi',
    'other_video_materials':'Dokumen video lainnya',
    'pass':'Lulus',
    'pass_streamer_join_agency_apply':'Lulus aplikasi untuk tuan rumah untuk bergabung dengan guild',
    'reject_streamer_join_agency_apply':'Tolak aplikasi tuan rumah untuk bergabung dengan guild',
    'agree_streamer_join_agency':'Setuju dengan jangkar {msg_ss1} untuk menjadi pengirim di bawah {msg_ss2}~',
    'reject_streamer_join_agency':'Permohonan anggota {msg_ss1} untuk menjadi anggota {msg_ss2} ditolak!',
    'img_material':'Dokumen gambar',
    'approver':'Penyetuju',
    'user_enter_bind_phone':'Silakan masukkan nomor ponsel',
    'vericode':'Kode verifikasi',
    'input_vericode':'Masukkan kode verifikasi',
    'login':'Gabung',
    'reg':'Terdaftar',
    'logout':'Keluar',
    'search_for':'Cari pencarian',
    'subscription_closed':'Kontrak yang dibatalkan',
    'agency_ID':'Kode serikat: {msg_ss}',
    'reset':'Setel ulang',
    'live_ID':'ID ruang siaran langsung',
    'live_record':'Rekaman layar siaran langsung',
    'email':'Email',
    'phone':'Telepon',
    'mastery_lang':'Bahasa yang dikuasai',
    'to':'Hingga',
    'cancel':'Batal',
    'Confirm':'Tentukan',
    'preview':'Pratinjau',
    'rejected':'Ditolak',
    'tip':'Notifikasi',
    'i_got_it':'Saya mengerti',
    'cancelled':'Dibatalkan',
    'refused':'Tolak',
    'agency_agree':'Persekutuan telah setuju',
    'platform_agree':'Platform telah setuju',
    'user_not_exist':'Pengguna ini tidak ada',
    'user_frozen':'Pengguna telah ditutup',
    'reviewing':'Dalam Tinjauan',
    'review_pass':'Tinjauan berlalu',
    'review_failed':'Audit gagal',
    'xx_hours':'{msg_ss} jam',
    'xx_days':'{msg_ss} hari',
    'xx_hour': '{msg_ss} Jam',
    'xx_day': '{msg_ss} Hari',
    'xx_year': '{msg_ss} Tahun',
    'xx_years': '{msg_ss} Tahun',
    'check_phone_istrue':'Silakan periksa nomor telepon apakah dimasukkan dengan benar',
    'male':'Laki-laki',
    'female':'Perempuan',
    'avatar':'Potret',
    'normal':'Normal',
    'live_room':'Ruang Live',
    'view':'Lihat',
    'oper_success':'Operasi sukses',
    'copy_success':'Berhasil disalin',
    'new_mobile_already_reg':'Nomor ponsel baru telah didaftarkan',
    'general_user':'Pengguna Umum',


    'copy':'Salin',
    'gender':'Gender',
    'submit':'Kirim',
    'permanent':'Permanen',
    'agree_agreement':'Setuju dan patuhi kontrak',
    'vericode_error':'Kode verifikasi salah',
    'resend':'Kirim ulang',
    'approved':'Lulus',
    'not_approved':'Gagal lulus',
    'agency_rejected':'Platform ditolak',
    'select':'Pilih',
    'search':'Cari',
    'rejection_reason':'Alasan penolakan',
    'no_data':'Tidak ada data',
    'oper_failed':'Operasi gagal',
    'leave_agency_apply':'Persetujuan untuk menarik guild',
    'over_word_limit':'Melebihi batas kata',
    'delete':'Hapus',
    'nickname':'Nama panggilan',
    'file_is_too_large':'File terlalu besar',

    'community_convention':'Konvensi Komunitas Buzzcast',
    'approval_time':'Waktu memproses',
    'guild_system_title':'Sistem Guild Platform Sosial BuzzCast',
    'return':'Kembali',
    'img_upload_fail':'Gagal unggahan gambar',
    'cooper_ing':'Dalam kerjasama',
    'upload_file_format_incorrect':'File yang diunggah tidak dalam format yang benar',
    'token_invalid':'Token tidak valid, silakan masuk lagi!',
    'network_busy':'Jaringan sedang sibuk, silakan coba lagi',
    'minute':'{msg_ss}menit',

    'live_room_ID':'ID Ruang Live',
    'scan_code':'Pindai kode untuk masuk di BuzzCast',
    'open_code':'Buka BuzzCastApp dan klik Kode QR Saya untuk memindai',
    'refresh':'Membaharui',
    'login_confirm':'Konfirmasi login',
    'account':'Informasi akun',
    'user_name':'Nama pengguna',
    'edit':'Merevisi',
    'changing':'Mengubah Nomor Pengikatan',
    'mobile_number':'Akun ponsel',
    'mobile_login':'Anda dapat masuk dengan menggunakan nomor ponsel {msg_ss}',
    'appId_login':'Anda dapat menggunakan akun dengan ID Aplikasi [{msg_ss}] untuk memindai agar masuk',
    'code_login':'BuzzCastAppID belum terikat. Setelah mengikat, Anda dapat masuk dengan memindai kode QR',
    'verification_log':'Nomor telepon belum terikat. Setelah mengikat, Anda dapat masuk dengan nomor ponsel dan kode verifikasi',
    'binding_success':'Pengikatan berhasil',
    'binding_mobile':'Mengikat nomor ponsel',
    'edit_name':'Mengubah nama pengguna',
    'binding_alert':'Pengingat perubahan pengikatan',
    'new_appId':'Langsung gunakan ID APP baru untuk memindai pengikatan kode. ID APP asli akan langsung diganti',
    'binding_account':'Mengikat akun Aplikasi BuzzCast',
    'anchor_earings':'Pendapatan jangkar',
    'signing_date':'Tanggal penandatanganan',
    'statistical_date':'Tanggal statistik',
    'valid_min':'Total Durasi Yang Valid (Menit)',
    'valid_day':'Hari yang valid (hari)',
    'total_revenue':'Total pendapatan',

    'bind':'Mengikat',
    'please_agree_agree':'Harap setujui kontraknya',
    'note':'Catatan: Waktu yang ditampilkan oleh sistem ini adalah waktu New York (EST)',
    'app_phone':'Daftarkan nomor ponsel APP',
    'host_num':'Jumlah tuan rumah',
    'enter_host_num':'Silakan masukkan nomornya dari semua host',
    'platform':'Platform kerjasama',
    'statement':'Laporan bank bulanan',
    'enter_income':'Masukkan pendapatan rata-rata per bulan',
    'check_commas':'Format salah. Silakan periksa apakah beberapa platform dipisahkan dengan koma',
    'submit_success':'Dokumen Anda telah berhasil dikirim! kami akan menanganinya sesegera mungkin',
    'usd':'USD',
    'many_platforms':'Silakan masuk ke platform siaran langsung tempat Anda bekerja sama sebelumnya, hingga 20 platform',
    'limit_platform': 'Hingga 20 platform',
    'user_has_delete':'Pengguna telah dibatalkan',
    'cant_commit':'Anda sudah menjadi penyiar yang dikontrak, dan Anda tidak dapat melamar guild untuk menetap pada saat yang bersamaan',
    'cant_commit_1':'Anda telah melamar penyiar yang dikontrak, dan Anda tidak dapat mengajukan guild untuk menetap pada saat yang bersamaan',
    'passwd': 'Kata sandi',
    'passwd_placeholder': 'Dukungan kata sandi 6 hingga 20',
    'live_rights': 'Penilaian bebas waktu',
    'edit_log': 'Ubah catatan',
    'edit_time': 'Ubah waktunya',
    'edit_pwd': 'Ganti kata sandi',
    'old_pwd': 'Password lama',
    'new_pwd': 'Kata sandi baru',
    'confirm_pwd': 'Konfirmasi sandi',
    'forget_pwd': 'Lupa kata sandi Anda?',
    'email_check': 'Format kotak surat salah',
    'phone_pwd_error': 'Nomor telepon atau kata sandi salah',
    'ten_min_error': 'Silakan coba lagi dalam 10 menit',
    'phone_bind_error': 'Nomor ponsel telah terikat ke akun lain, harap ganti nomor ponsel baru untuk mengikat.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'ID pemimpin serikat sudah diisi, silakan isi lagi',
    'pwd_error': 'Kata sandi salah',
    'phone_not_reg_error': 'Akun tidak terdaftar',
    'pwd_nq': 'Kata sandi baru yang dimasukkan dua kali tidak konsisten',
    'sign_anchor_error': 'Anda sudah menjadi penyiar yang dikontrak, dan Anda tidak dapat melamar guild untuk menetap pada saat yang bersamaan',
    'apply_anchor_error': 'Anda telah melamar penyiar yang dikontrak, dan Anda tidak dapat mengajukan guild untuk menetap pada saat yang bersamaan',
    'have-expired':'Kedaluwarsa',
    'approval-time':'Waktu pengerjaan',
    'reasons-for-refusal':'Masukkan alasan penolakan',
    'Transfer-grounds':'Alasan transfer',
    'code_expire': 'Kode verifikasi telah kedaluwarsa, silakan klik kode verifikasi untuk menyegarkan kembali',
    'transfer-approval':'Persetujuan transfer',
    'live_state_placeholder': 'Status mulai',
    'live_state_open': 'Normal',
    'live_state_temporary_banned': 'Dilarang',
    'live_state_forever_banned': 'Dilarang secara permanen',
    'live_allowed_time': 'Waktu mulai yang diizinkan',
    'live_banned_time': 'Siklus off-air',
    'deduct_money': 'Kurangi jumlah koin B',
    'final_income': 'Pendapatan nyata',
    'select_start_dt': 'Silakan pilih waktu mulai',
    'select_end_dt': 'Silakan pilih waktu akhir',
    'less_then_end_dt': 'Waktu mulai harus kurang dari atau sama dengan akhir waktu',
    'System_automatically_through':'Sistem secara otomatis melewati',
    'btrade_err': 'ID agensi tidak tersedia',

    'mouth_anchor': 'Ancoraggio salariale mensile',
    'day_anchor': 'Ancoraggio salariale giornaliero',
    'guild_anchor': "Ricompensa del capo dell'associazione di ancoraggio (stipendio giornaliero)",
    'mouth_anchor_st': 'Waktu mulai gaji bulanan',
    'mouth_anchor_et': 'Waktu akhir gaji bulanan',
    'day_anchor_st': 'Waktu mulai gaji harian',
    'day_anchor_et': 'Waktu akhir gaji harian',
    'all_award_bcoin': 'Total pendapatan hadiah gaji harian',
    'live_hour': 'Hadiah durasi efektif siaran langsung',
    'salary_day': 'Tanggal',
    'day_in_come': 'Pendapatan guild hari tersebut (Koin B)',
    'award_ration_flag_str': 'Persentase hadiah',
    'payable_money': 'Hadiah Koin B ketua guild',
    'host_bcoins': 'Koin B keuntungan penyiar ',
    'total_official': 'Total jumlah Koin B hadiah pihak resmi',
    'actual_bcoins_awarded': 'Koin B hadiah aktual',
    "change_bound_account":"Ganti tautan akun" ,
    "agent_id_form":"ID ketua guild:" ,
    "BuzzCast_verification_code":"Kode verifikasi BuzzCast:" ,
    "send_success":"Berhasil dikirim" ,
    "account_changed_successfully":"Berhasil mengganti tautan akun" ,
    "invite_guild_url":"Tautan undangan menjadi ketua guild BuzzCast: {msg_ss}" ,
    "invite_guild_code":"Kode undangan saya: {msg_ss}" ,
    "save":"Simpan" ,
    "compile":"Mengedit" ,
    "agent_nvitation_eward":"Hadiah undangan ketua guild" ,
    "agent_name":"Nama panggilan ketua guild" ,
    "guild_id":"Kode guild" ,
    "guild_income_30days":"Pendapatan guild dalam 30 hari terakhir" ,
    "guild_invite_income_30days":"Pendapatan undangan guild dalam 30 hari terakhir" ,
    "agency_commission_ratio":"Rasio Komisi Agensi" ,
    "invite_income_bcoins":"Undangan memberi hadiah B koin" ,
    "id_not_exist": "ID tidak ada",
    'reward_distribution_status': 'Status distribusi hadiah',
    'must_number': 'Masukan Anda harus dalam format numerik murni.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/id.js